<template>
  <div class="layout-wrap">
    <Loading />
    <router-view />
    <ApiErrorDialog />
  </div>
</template>

<script>
export default {
  components: {
    ApiErrorDialog: () => import('../ui/ApiErrorDialog.vue'),
    Loading: () => import('../ui/Loading.vue')
  }
}
</script>